import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import csrData from "../content/Csr.json"; // Import JSON file
import csrHeroImage from "../assets/images/8T6A0836.jpg";
import approachImage from "../assets/images/SCHOOL_IMG_3896.jpg";
import headTeacherImage from "../assets/images/HEADMASTER_IMG_3890.jpg";
import computerLabImage from "../assets/images/computer_Lab.jpg";
import Livestoc from "../assets/images/Livestoc.jpg";
import Healthcare from "../assets/images/Healthcare.jpg";
import Emergency from "../assets/images/EmergencyResponse.jpg";
import chandauliSchoolImage from "../assets/images/Chandauli_school.jpg";
import selfHelpLeaderImage from "../assets/images/Self-help group leader.jpg";
import csrActionPlanPdf from "../assets/csr_pdf/Approved_CSR_annual_action_plan_FY26-27.pdf";

const CsrFromData = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [activeOverlay, setActiveOverlay] = useState(null);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 768 : false,
  );
  const pdfMap = {
    CSR_SUMMARY_PDF :"csr-document",
    CSR_ACTION_PLAN_PDF: csrActionPlanPdf,
  };

  useEffect(() => {
    // Load data from JSON and ensure hero image resolves via import
    const resolvedFocusAreas =
  csrData.focusAreas?.items?.map((item) => {
    if (item.title === "Rural School Transformation & Digital Learning") {
      return {
        ...item,
        image: computerLabImage,
      };
    }

    if (item.title === "Livestock Livelihoods & Climate-smart Fodder") {
      return {
        ...item,
        image: Livestoc,
      };
    }

    if (item.title === "Primary Healthcare at the Doorstep") {
      return {
        ...item,
        image: Healthcare,
      };
    }
 if (item.title === "Emergency Response & Community Resilience") {
      return {
        ...item,
        image: Emergency,
      };
    }

    return item;
  }) ?? [];
    const resolvedData = {
      ...csrData,
      heroSection: {
        ...csrData.heroSection,
        heroImage: csrHeroImage,
      },
      approachSection: {
        ...csrData.approachSection,
        image: approachImage,
      },
      focusAreas: {
        ...csrData.focusAreas,
        items: resolvedFocusAreas,
      },
      impactStory: {
        ...csrData.impactStory,
        image: chandauliSchoolImage,
      },
      testimonials: {
        ...csrData.testimonials,
        items: csrData.testimonials.items.map((item, idx) =>
          idx === 0
            ? { ...item, image: headTeacherImage }
            : idx === 1
              ? { ...item, image: selfHelpLeaderImage }
              : item,
        ),
      },
    };
    setData(resolvedData);
    setLoading(false);

    let timer = null;

    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "auto" });
      timer = window.setTimeout(() => setOverlayVisible(true), 1000);
    } else {
      timer = setTimeout(() => setOverlayVisible(true), 2000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
      setActiveOverlay(null);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) {
    return <div className="text-center py-20">Loading...</div>;
  }

  if (!data) {
    return <div className="text-center py-20">No data available</div>;
  }

  return (
    <main className="bg-ofWhite text-white1">
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <img
          src={data.heroSection.heroImage}
          alt="CSR impact hero"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/60 to-black/40" />
        <div className="relative max-w-7xl mx-auto px-4 lg:px-0 py-20 lg:py-40">
          <div
            className={`relative max-w-xl transition-all duration-700 ease-out ${
              overlayVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"
            }`}
          >
            <div className="absolute inset-0 rounded-3xl border border-white/15 bg-black/45 backdrop-blur-2xl shadow-[0_35px_120px_rgba(0,0,0,0.65)]" />
            <div className="relative space-y-6 text-white px-6 py-8 rounded-3xl sm:px-8 sm:py-10 lg:px-10 lg:py-12">
              <p className="uppercase text-xs tracking-[0.4em] text-white/70">
                {data.heroSection.tagline}
              </p>
              <h1 className="text-3xl md:text-4xl xl:text-5xl font-semibold leading-tight">
                {data.heroSection.title}
              </h1>
              <p className="text-base md:text-lg text-white/90">
                {data.heroSection.subtitle}
              </p>
              <div className="flex flex-wrap gap-4 pt-2">
                <Link
                  to="#our-story"
                  className="inline-flex items-center px-6 py-3 rounded-full bg-red text-white font-semibold shadow-[0_12px_30px_rgba(30,64,175,0.35)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-black"
                >
                  Read the full story
                  <span className="ml-2 text-lg" aria-hidden="true">
                    ↓
                  </span>
                </Link>
                <Link
                  to="/csr-document"
                  className="inline-flex items-center px-6 py-3 rounded-full bg-white/90 text-primary font-semibold transition-colors duration-200 hover:bg-white"
                >
                  Download CSR documents
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Approach Section */}
      <section
        id="our-story"
        className="max-w-7xl mx-auto px-4 lg:px-0 py-20 lg:py-28"
      >
        <div className="grid grid-cols-1 lg:grid-cols-[3fr,2fr] gap-12 items-center">
          <div className="space-y-6">
            <p className="text-sm uppercase tracking-[0.4em] text-red">
              {data.approachSection.label}
            </p>
            <h2 className="text-3xl lg:text-4xl font-semibold leading-snug">
              {data.approachSection.heading}
            </h2>
            <p className="text-base lg:text-lg text-white1/80">
              {data.approachSection.description}
            </p>
            <p className="text-base lg:text-lg text-white1/80">
              {data.approachSection.additionalText}
            </p>
          </div>
          <div className="relative rounded-3xl overflow-hidden shadow-lg min-h-[260px] sm:min-h-[360px]">
            <img
              src={data.approachSection.image}
              alt="Approach"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-primary/80 via-black/70 to-black/60" />
          </div>
        </div>
      </section>

      {/* Focus Areas Section */}
      <section className="bg-white3 py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 lg:px-0 space-y-12">
          <header className="max-w-3xl space-y-4">
            <p className="text-xs uppercase tracking-[0.35em] text-red">
              {data.focusAreas.subheading}
            </p>
            <h2 className="text-3xl lg:text-4xl font-semibold">
              {data.focusAreas.heading}
            </h2>
            <p className="text-base lg:text-lg text-white1/70">
              {data.focusAreas.content}
            </p>
          </header>
          <div
            className="grid gap-6 lg:grid-cols-2"
            onClick={() => {
              if (!isDesktop) setActiveOverlay(null);
            }}
          >
            {data.focusAreas.items.map((area, index) => (
              <article
                key={area.title}
                tabIndex={0}
                className="group relative h-[360px] sm:h-[420px] rounded-3xl overflow-hidden shadow-xl border border-white2 focus-visible:ring-4 focus-visible:ring-primary/30 transition-transform duration-300"
                onClick={(e) => {
                  if (isDesktop) return;
                  e.stopPropagation();
                  setActiveOverlay((prev) => (prev === index ? null : index));
                }}
              >
                <img
                  src={area.image}
                  alt={area.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div
                  className="absolute inset-0 transition-opacity duration-500"
                  style={{
                    background:
                      "linear-gradient(to bottom, rgba(255,255,255,0), rgba(0,0,0,1))",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <div className="absolute bottom-8 left-8 right-8 z-10 space-y-3">
                  <h3 className="text-2xl font-semibold text-white3">
                    {area.title}
                  </h3>
                  <p className="text-xs uppercase tracking-[0.35em] text-white/70">
                    {area.statLine}
                  </p>
                </div>
                <div className="absolute inset-0 z-20 flex items-end md:items-center justify-center px-4 sm:px-6">
                  <div
                    className={`w-full bg-black/70 md:bg-black/80 backdrop-blur-sm rounded-3xl px-5 py-6 sm:px-6 sm:py-7 text-white3 space-y-3 shadow-[0_20px_60px_rgba(0,0,0,0.35)] transition-all duration-300 ${
                      isDesktop
                        ? "opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 pointer-events-none"
                        : activeOverlay === index
                          ? "opacity-100 translate-y-0"
                          : "opacity-0 translate-y-3 pointer-events-none"
                    }`}
                  >
                    <p className="text-xs text-white/70 uppercase tracking-[0.3em]">
                      Programme snapshot
                    </p>
                    <p className="text-sm leading-relaxed">{area.summary}</p>
                    <p className="text-sm text-white/80">{area.description}</p>
                    <p className="text-[11px] uppercase tracking-[0.35em] text-accent">
                      {area.statLine}
                    </p>
                  </div>
                </div>
                {!isDesktop && activeOverlay !== index && (
                  <div className="absolute bottom-4 right-4 z-30">
                    <span className="inline-flex items-center gap-1 rounded-full bg-black/75 text-white px-3 py-1 text-[11px] uppercase tracking-[0.25em] shadow-md">
                      Tap to view
                    </span>
                  </div>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Vision 2030 Section */}
      {/* <section className="max-w-7xl mx-auto px-4 lg:px-0 py-20 lg:py-28">
        <div className="rounded-3xl bg-gradient-to-br from-white via-ofWhite to-light text-white1 shadow-2xl overflow-hidden">
          <div className="grid gap-10 lg:grid-cols-[2fr,3fr] p-6 sm:p-10 lg:p-16">
            <div className="space-y-4">
              <p className="text-xs uppercase tracking-[0.4em] text-white1/60">
                {data.vision2030.headline}
              </p>
              <h2 className="text-3xl lg:text-4xl font-semibold leading-snug">
                {data.vision2030.subheading}
              </h2>
              <p className="text-base text-white1/80">
                {data.vision2030.description}
              </p>
            </div>
            <ul className="space-y-4 text-base leading-relaxed text-white1/80 list-disc pl-6">
              {data.vision2030.pillars.map((pillar, index) => (
                <li key={index}>{pillar}</li>
              ))}
            </ul>
          </div>
          <div className="bg-white2/50 text-white1/70 text-xs uppercase tracking-[0.45em] px-6 py-4">
            Vision milestone — {data.vision2030.milestone}
          </div>
        </div>
      </section> */}

      {/* Impact Story Section */}
      <section className="bg-black text-white3 py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 lg:px-0 space-y-12">
          <header className="max-w-3xl space-y-4">
            <p className="text-xs uppercase tracking-[0.35em] text-white/70">
              {data.impactStory.heading}
            </p>
            <h2 className="text-3xl lg:text-4xl font-semibold">
              {data.impactStory.subheading}
            </h2>
            <p className="text-base text-white/75">
              {data.impactStory.paragraph}
            </p>
          </header>
          <div className="grid gap-10">
            <article className="group relative h-[360px] md:h-[460px] rounded-3xl overflow-hidden shadow-2xl border border-white/10">
              <img
                src={data.impactStory.image}
                alt={data.impactStory.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent transition-opacity duration-300 group-hover:bg-black/70" />
              <div className="absolute inset-0 flex flex-col justify-end">
                <div className="px-10 pb-10">
                  <h3 className="text-2xl font-semibold leading-snug text-white3">
                    {data.impactStory.title}
                  </h3>
                </div>
              </div>
              <div className="absolute inset-0 flex flex-col justify-end">
                <div className="max-h-0 group-hover:max-h-full group-hover:pb-10 px-10 transition-all duration-500 ease-out overflow-hidden">
                  <div className="bg-white3/10 backdrop-blur-md rounded-3xl px-8 py-8 space-y-4 text-white3 shadow-2xl max-h-64 overflow-y-auto">
                    <span className="text-xs uppercase tracking-[0.35em] text-white/70 block">
                      {data.impactStory.location}
                    </span>
                    <p className="text-base text-white/85 leading-relaxed">
                      {data.impactStory.narrative}
                    </p>
                    <p className="text-sm font-semibold text-accent uppercase tracking-[0.3em]">
                      {data.impactStory.highlight}
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="max-w-7xl mx-auto px-4 lg:px-0 py-20 lg:py-28 space-y-12">
        <header className="space-y-3 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.35em] text-red">
            {data.testimonials.heading}
          </p>
          <h2 className="text-3xl lg:text-4xl font-semibold text-black">
            {data.testimonials.subheading}
          </h2>
        </header>
        <div className="grid gap-8 lg:grid-cols-2">
          {data.testimonials.items.map((testimonial, index) => (
            <article
              key={index}
              tabIndex={0}
              className="group bg-white3 rounded-3xl overflow-hidden shadow-xl border border-white2 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex flex-col h-full">
                <div className="relative h-56 lg:h-64 overflow-hidden">
                  <img
                    src={testimonial.image}
                    alt={testimonial.attribution}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    style={
                      index === 0 ? { objectPosition: "center 15%" } : undefined
                    }
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/25 to-transparent transition-opacity duration-500 group-hover:from-black/55" />
                </div>
                <div className="flex-1 p-8 space-y-4">
                  <span className="text-5xl text-red leading-none">"</span>
                  <p className="text-lg leading-relaxed text-black">
                    {testimonial.quote}
                  </p>
                  <footer className="pt-4 text-sm font-semibold text-white1/70 uppercase tracking-wide">
                    {testimonial.attribution}
                  </footer>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Governance Section */}
      <section className="bg-white3 py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 lg:px-0 space-y-12">
          <header className="max-w-3xl space-y-4">
            <p className="text-xs uppercase tracking-[0.35em] text-red">
              {data.governanceHighlights.heading}
            </p>
            <h2 className="text-3xl lg:text-4xl font-semibold text-black">
              {data.governanceHighlights.subheading}
            </h2>
          </header>
          <ul className="space-y-4 text-base text-white1/75 leading-relaxed list-disc pl-6">
            {data.governanceHighlights.items.map((highlight, index) => (
              <li key={index}>{highlight}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 lg:px-0 py-20 lg:py-28 space-y-12">
        <header className="max-w-3xl space-y-3">
          <p className="text-xs uppercase tracking-[0.35em] text-red">
            {data.dataWall.heading}
          </p>
          <h2 className="text-3xl lg:text-4xl font-semibold text-black">
            {data.dataWall.subheading}.
          </h2>
        </header>
        <div className="grid gap-6 lg:grid-cols-2">
          {data.dataWall.items
            .filter(
              (item) =>
                item.trim() !==
                "CSR outlay (Sonata FY 2023–24): ₹50,00,000 across solar, school and monitoring projects.",
            )
            .map((item, index) => (
              <div
                key={index}
                className="bg-white3 border border-white2 rounded-3xl p-6 text-base text-white1/75"
              >
                {item}
              </div>
            ))}
        </div>
      </section>

      {/* Downloads Section */}
      <section id="downloads" className="bg-primary text-white3 py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 lg:px-0 space-y-10">
          <header className="space-y-3 max-w-3xl">
            <p className="text-xs uppercase tracking-[0.35em] text-white/70">
              {data.downloads.heading}
            </p>
            <h2 className="text-3xl lg:text-4xl font-semibold">
              {data.downloads.subheading}
            </h2>
          </header>
          <div className="grid gap-6 lg:grid-cols-2">
            {data.downloads.item.map((file) => (
              <div
                key={file.label}
                className="bg-white3/10 border border-white/20 rounded-3xl p-6 flex flex-col gap-4"
                
              >
                <div className="flex justify-between">
                  <div className="text-center">
                  <h3 className="text-xl font-semibold">{file.label}</h3>
                  <p className="text-sm text-white/80">{file.description}</p>
                </div>
                <div>
                  <a
                  href={pdfMap[file.href]}
                  className="mx-auto inline-flex items-center justify-start text-sm font-semibold text-white3 hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download
                  <span className="ml-2 text-lg" aria-hidden="true">
                    ↓
                  </span>
                </a>
                  </div>
                  </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-black py-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-0 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div >
            <h2 className="text-2xl lg:text-3xl font-semibold text-white3">
              {data.cta.heading}
            </h2>
            <p className="text-sm text-white/80 mt-2">{data.cta.description}</p>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center px-6 py-3 rounded-full bg-white3 text-primary font-semibold hover:bg-white2 transition-colors"
          >
            {data.cta.buttonText}
            <span className="ml-2 text-lg" aria-hidden="true">
              →
            </span>
          </Link>
        </div>
      </section>
    </main>
  );
};

export default CsrFromData;
